export default __webpack_public_path__ + "130e6a9a42858e02527bf203f2dd7f37.gif";